const localStorageKey = "Language-f2146029-be78-4f32-b8f4-08ac5fea1247";
export const loadLanguage = () => (localStorage.getItem(localStorageKey) ?? "da");
export const saveLanguage = (language) => {
    localStorage.setItem(localStorageKey, language);
};
